const flattenObject = (object, flattened = []) => {
  console.log("flattened", flattened);
  console.log("object", object);
  if (
    object === null ||
    object === undefined ||
    typeof object === "number" ||
    typeof object === "string"
  ) {
    flattened.push(object);
  } else if (Array.isArray(object)) {
    object.forEach((item) => {
      flattenObject(item, flattened);
    });
  } else if (typeof object === "object") {
    Object.values(object).forEach((item) => {
      flattenObject(item, flattened);
    });
  }
  return flattened;
};
export const validateRegime = (matrices) => {
  return matrices.every((matrix) => {
    const flattened = flattenObject(matrix);
    return flattened.every((item) => {
      return item !== null && item !== undefined && item !== "";
    });
  });
};
